module.exports = __webpack_public_path__ + "static/media/logo.ec5039d1.png";